// extracted by mini-css-extract-plugin
export default {"AppLink":"mVYHWKRA","icon":"mE4ixgad","reverse":"LqYOm8YI","primary":"lPwbqaEz","spinner":"lxFFdBFz","accent":"xR1lCZFM","buttonModalText":"ziaYWmYE","inverted":"LrMefQGc","navigation":"CWx_KxPQ","xl":"AdIpptJr","l":"QpQu1Jce","m":"kdQXkn5J","s":"wAkFVve3","xs":"sc57FbAe"};
    if(module.hot) {
      // 1776432162265
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  